export const TicketType = {
  COMMON : 1,
  HALF_ENTRY : 2,
  FAN_MEMBER : 4,
  COMPANION : 5,
  DEPENDENT : 6,
  CHECKIN_MEMBER : 11,
} as const;

type TicketTypeType = (typeof TicketType)[keyof typeof TicketType];

export type { TicketTypeType };
